import { std } from "mathjs";
import * as valuePrecisionConverter from "../../../Lumber/ValuePrecisionConverter";
import _ from "lodash";

import type { StandardDeviationInput } from "./types";

/** The coefficient of variation of the rows' averages, as a "<n>%" string ("N/A" when there is no data). */
export function calculateStandardDeviationForCompiledTable(data: StandardDeviationInput): string {
	if (data === null || data === undefined || _.isEmpty(data)) {
		return "N/A";
	}
	const values = _.map(data, "average");
	const mean = _.meanBy(values);
	const standardDeviation = (std(values) / mean) * 100;
	// ValuePrecisionConverter is untyped JS; getPrecision returns a number for a truthy number input.
	const stdDev = valuePrecisionConverter.getPrecision(standardDeviation) as number;
	return `${Math.abs(stdDev)}%`;
}
